var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 27C47.25 21.6294 45.1165 16.4787 41.3189 12.6811C37.5213 8.88348 32.3706 6.75 27 6.75C21.3389 6.7713 15.9052 8.98025 11.835 12.915L6.75 18M6.75 18V6.75M6.75 18H18M6.75 27C6.75 32.3706 8.88348 37.5213 12.6811 41.3189C16.4787 45.1165 21.6294 47.25 27 47.25C32.6611 47.2287 38.0948 45.0197 42.165 41.085L47.25 36M47.25 36H36M47.25 36V47.25",
    stroke: "#3E3E3E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8944 16.6682C25.9426 16.4102 26.0795 16.1772 26.2814 16.0095C26.4833 15.8418 26.7375 15.75 27 15.75C27.2625 15.75 27.5167 15.8418 27.7186 16.0095C27.9205 16.1772 28.0574 16.4102 28.1056 16.6682L29.2877 22.9195C29.3717 23.3639 29.5876 23.7727 29.9075 24.0925C30.2273 24.4124 30.6361 24.6283 31.0805 24.7123L37.3318 25.8944C37.5898 25.9426 37.8228 26.0795 37.9905 26.2814C38.1582 26.4833 38.25 26.7375 38.25 27C38.25 27.2625 38.1582 27.5167 37.9905 27.7186C37.8228 27.9205 37.5898 28.0574 37.3318 28.1056L31.0805 29.2877C30.6361 29.3717 30.2273 29.5876 29.9075 29.9075C29.5876 30.2273 29.3717 30.6361 29.2877 31.0805L28.1056 37.3318C28.0574 37.5898 27.9205 37.8228 27.7186 37.9905C27.5167 38.1582 27.2625 38.25 27 38.25C26.7375 38.25 26.4833 38.1582 26.2814 37.9905C26.0795 37.8228 25.9426 37.5898 25.8944 37.3318L24.7123 31.0805C24.6283 30.6361 24.4124 30.2273 24.0925 29.9075C23.7727 29.5876 23.3639 29.3717 22.9195 29.2877L16.6682 28.1056C16.4102 28.0574 16.1772 27.9205 16.0095 27.7186C15.8418 27.5167 15.75 27.2625 15.75 27C15.75 26.7375 15.8418 26.4833 16.0095 26.2814C16.1772 26.0795 16.4102 25.9426 16.6682 25.8944L22.9195 24.7123C23.3639 24.6283 23.7727 24.4124 24.0925 24.0925C24.4124 23.7727 24.6283 23.3639 24.7123 22.9195L25.8944 16.6682Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfinity);
export default __webpack_public_path__ + "static/media/icon-infinity.09f210f1df0e7d3e36ac55a59ecfcef2.svg";
export { ForwardRef as ReactComponent };